goog.provide("shadow.js.shim.module$$mui$material$AppBar");
goog.provide("module$shadow_js_shim_module$$mui$material$AppBar");
shadow.js.shim.module$$mui$material$AppBar = shadow.js.nativeProvides["@mui/material/AppBar"] = shadow$bridge("@mui/material/AppBar");
module$shadow_js_shim_module$$mui$material$AppBar.default = shadow.js.shim.module$$mui$material$AppBar;
